<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-6 py-1 px-2"
      dense
      height="30"
    >
      <v-toolbar-title class="mt-4 me-4">{{ $t('entrepotList') }}</v-toolbar-title>
      <div
        v-if="!isMobile && !isTablet"
        style="width: 230px;"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </div>
      <v-spacer />
      <v-btn
        v-if="selected.length > 0 && !isMobile"
        outlined
        @click="deletDialog = true"
        class="mt-4 ms-2"
        color="pink"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('remove') }}
        </p>
        <v-icon>
          mdi-trash-can-outline
        </v-icon>
      </v-btn>
      <v-menu
        offset-y
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            outlined
            class="mt-4 px-1 ms-2"
            color="grey darken-2"
            height="32"
            v-bind="attrs"
            v-on="on"
            style="min-width: 35px !important;padding: 0 !important;"
          >
            <!-- <p class="mb-0 me-2">
              {{$t('more')}}
            </p> -->
            <v-icon>
              mdi-dots-vertical
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <log
            v-if="$store.state.permissions && $store.state.permissions.includes('logList')"
            ref="logRef"
            :type-prop="typeForm"
            :listProp="true"
            mode-prop="button"
          />
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="getItems"
          >
            <v-list-item-icon>
              <v-icon>mdi-refresh</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('refresh')" />
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="printDialog = true"
          >
            <v-list-item-icon>
              <v-icon>mdi-printer-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('print')" />
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="goTo('entrepot')"
          >
            <v-list-item-icon>
              <v-icon>mdi-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('entrepot')" />
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="getItems"
        class="mt-4 px-1 ms-2"
        color="grey darken-2"
        height="32"
        @shortkey="getItems"
        v-shortkey="['f5']"
        style="min-width: 35px !important;padding: 0 !important;"
      >
        <!-- <p class="mb-0 me-2">
          {{$t('refresh')}}
        </p> -->
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="printDialog = true"
        class="mt-4  ms-2"
        color="grey darken-2"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('print') }}
        </p>
        <v-icon>
          mdi-printer-outline
        </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="goTo('entrepot')"
        class="mt-4 ms-2"
        color="primary"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('entrepot') }}
        </p>
        <v-icon>
          mdi-plus
        </v-icon>
      </v-btn>
    </v-app-bar>
    <v-row
      v-if="isMobile || isTablet"
      class="mx-0"
    >
      <v-col
        class="mb-4 px-2"
        cols="12"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-col
      cols="12"
      class="px-2"
      :class="{ 'mt-6': !isMobile && !isTablet , 'mt-0': isMobile || isTablet}"
    >
      <v-data-table
        v-if="headers"
        :height="(isMobile || isTablet || mobileShow ? 323 : tableHeight)"
        fixed-header
        v-model="selected"
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :page.sync="page"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        class="mb-2 td-hide-border"
        style="border: 1px solid #e3e3e3;border-radius: 6px;"
        :footer-props="{
          showFirstLastPage: (!mobileShow ? true : false),
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus'
        }"
      >
        <template v-slot:item.actions="{ item }">
          <v-menu
            offset-y
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="primary"
                v-bind="attrs"
                icon
                v-on="on"
              >
                <v-icon
                  medium
                >
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item
                link
                @click="edit(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                v-clipboard:copy="$baseURL + '/' + (typeForm == 'product' ? 'product':'service') +'/edit/' + item.id"
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
              <log
                :title-prop="$t('history')"
                icon-prop="mdi-history"
                :listProp="true"
                :type-prop="typeForm"
                :refIdProp="item.id"
                mode-prop="button"
              />
              <v-list-item
                link
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink">
                    mdi-trash-can-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="item.user"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                {{ item.user.firstname }}  {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.id="{ item }">
          <a @click="edit(item)">
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.name="{ item }">
          {{ item.name }}
        </template>
        <template v-slot:item.address="{ item }">
          {{ item.address != null ? item.address : 'ندارد' }}
        </template>
        <template v-slot:item.row="{ item }">
          <a @click="edit(item)">
            {{ parseInt(items.indexOf(item))+ parseInt(from) }}
          </a>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:footer.prepend>
          <v-col
            v-show="!isMobile"
            cols="1"
            class="pa-0"
            style="margin-top: -10px"
          >
            <v-text-field
              v-model.number="page"
              :label="$t('goToPage')"
              min="1"
              :max="pageCount"
              type="number"
              outlined
              height="32"
              hide-details
              hide-spin-buttons
              dense
              :suffix="'  /  ' + pageCount"
            />
          </v-col>
        </template>
      </v-data-table>
    </v-col>
    <v-row />
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
  import Print from '../../components/general/Print/Index'
  import General from '../../../../Mixins/general'
  export default {
    name: 'warehouseList',
    components: {
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      Print,
    },
    mixins: [General],
    props: ['input', 'refId', 'mobileShow'],
    data: () => ({
      selected: [],
      pageCount: 1,
      page: 1,
      printDialog: false,
      deletDialog: false,
      filter: false,
      productStatus: null,
      productStatusItems: null,
      model: null,
      from: 1,
      taskDialog: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      typeForm: 'warehouse',
      taskId: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      headers: null,
      type: null,
      search: null,
    }),
    computed: {
      showSelect () {
        if(!this.isMobile) {
          return true
        } else {
          return false
        }
      },
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
    },
    watch: {
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        app.page = 1
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
    },
    activated () {
      this.getItems()
    },
    beforeMount () {
      this.headers = [
        {
          text: this.$t('actions'),
          align: 'start',
          sortable: false,
          value: 'actions',
          width: 20,
        },
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'row',
          width: 20,
        },
        {
          text: this.$t('id'),
          sortable: true,
          value: 'id',
          table: 'entrepots.id',
        },
        {
          text: this.$t('name'),
          sortable: true,
          value: 'name',
          table: 'entrepots.name',
        },
        {
          text: this.$t('address'),
          sortable: true,
          value: 'address',
          table: 'entrepots.address',
        },
        {
          text: this.$t('registerar'),
          sortable: false,
          value: 'user.name',
        },
      ]
      if (this.$route.params.id != null) {
        this.show()
        this.id = this.$route.params.id
        this.render = false
      }
    },
    mounted () {
      if (this.input) {
        this.model = this.input
      }
      this.getItems()
    },
    methods: {
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: 'entrepotEdit', params: { id: item.id } })
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'warehouse', {
          params: {
            search: app.search,
            page: app.options.page,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.options,
          },
        })
          .then(res => {
            res = res.data
            app.items = res.data
            app.totalItems = res.total
            app.pageCount = res.last_page
            app.from = res.from
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'warehouse/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      removegroup () {
        var app = this
        app.loading = true
        app.$axios.delete(this.$endpoint + 'warehouse/0', {
          params: { deleteItems: app.selected },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
    },
  }
</script>

<style scoped>
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 32px !important;
}
</style>
